import React, { Component } from 'react';
import { Link } from 'react-router-dom';


class AddClapbackForm extends Component {
  constructor(props) {
    super(props);
    this.screen = '';
    this.state = {
      
    }; 
  }
  
  componentDidMount() {
  }

  componentDidUpdate(){
  }

  toggleForm = (e) => {
    // e.preventDefault();

    // var formElement = document.getElementById('addWSDEform');
    // var formData = new FormData(formElement);
    // var request = new XMLHttpRequest();
    // var contentHead = "Submission for WSDE Map: /n";
    // var formInputs = [
    //   "businessName",
    //   "address",
    //   "city",
    //   "state",
    //   "zip",
    //   "website",
    //   "phone",
    //   "businessEmail"
    // ];
    // var contentBody = formInputs.map(input => {
    //   const line = input + ": " + formData.get(input) + "/n";
    //   return line;
    // });
    // var content = contentHead + contentBody;
    // formData.append("content", content);
    // request.open("POST", "/contact/send");
    // request.send(formData);
    this.props.toggleForm()
  }

  render() {
    // const {} = this.state;
  
    return (
      <React.Fragment>
        <div id="addClapbackformHold">
          <div className="formIntro tfStage blkT">
            <h3 className="upperT">Tell it.</h3>
          </div>
          <form id="addClapbackform" className="contactForm tfStage" action="/clapback-chest/add" method="post">
            <input className="formItem resourceAuthor relative" name="prompt" type="text" placeholder="PROMPT"></input>
            <input className="formItem resourceAuthor relative" name="response" type="text" placeholder="RESPONSE"></input>
            <input className="formItem resourceAuthor relative" name="senderName" type="text" placeholder="YOUR NAME"></input>
            <input className="formItem resourceAuthor relative" name="senderEmail" type="email" placeholder="YOUR EMAIL"></input>
            <input className="buttonCTA formButton upperT boldT" type="submit" value='Send'></input>
          </form>
        </div>
      </React.Fragment>
    )
  }
}
  
export default AddClapbackForm;



// WEBPACK FOOTER //
// ./src/components/resources/awp/clapbackForm.js